import { basicTask } from "./task";
import { swiperInit } from "./swiper";
const bodyWrap = document.querySelector("body");
const sideNav = document.querySelector(".sidenav-group");
const menuMobile = document.querySelector(".mobile-nav-wrap");
const searchWrap = document.querySelector(".search-overlay");
let resizeTimeout;





document.addEventListener("DOMContentLoaded", () => {
	Fancybox.bind("[data-fancybox]", {
		parentEl: document.querySelector("form"), // Adjust this reference
	});
	mappingFunc();
	swiperInit();
	basicTask();
	lozadInit();
	generalFunction.init();
});


window.addEventListener("resize", function () {
	clearTimeout(resizeTimeout);

	resizeTimeout = setTimeout(() => {
		let width = this.window.innerWidth;
		if (width <= 1200.1) {
			mappingFunc();

		}
		generalFunction.init();
	}, 1000);
});
window.addEventListener("scroll", function () {
	const width = this.window.innerWidth;
	const scrollTop = window.scrollY || document.documentElement.scrollTop;
	if (width >= 1200.1) {
		if (
			document.body.scrollTop > 100 ||
			document.documentElement.scrollTop > 100
		) {
			bodyWrap.classList.add("minimize");
		} else {
			bodyWrap.classList.remove("minimize");
		}
	}
	if (scrollTop > window.innerHeight) {
		sideNav.classList.add("show");
	} else {
		sideNav.classList.remove("show");
	}
});
document.addEventListener("click", (event) => {
	if (!event.target.closest(".search-toggle, .search-overlay")) {
		searchWrap.classList.remove("is-open");
	}

});
$(".select-js").each(function () {
	var $select = $(this);
	var $section = $select.closest("section");
	var $tabSelectContainer = $select.closest(".tab-select");
	$select.select2({ minimumResultsForSearch: Infinity });
	$select.on("change", function () {
		var target = $(this).val();
		if ($tabSelectContainer.length) {
			$section.find(".tab-select-item").removeClass("is-active");
			if (target) {
				$section.find("#" + target).addClass("is-active");
			}
		}
	});
	if ($select.val()) {
		$select.trigger("change");
	} else {
		if ($tabSelectContainer.length) {
			$section.find(".tab-select-item").first().addClass("is-active");
		}
	}
});



const lazyLoader = lozad(".lozad", {
	rootMargin: "10px 0px", // syntax similar to that of CSS Margin
	threshold: 0.2, // ratio of element convergence
	enableAutoReload: true, // it will reload the new image when validating attributes changes

});

export function lozadInit() {
	lazyLoader.observe();
	window.lazyLoader = lazyLoader;
}
const generalFunction = {

	scrollReveal: () => {
		if ($(window).width() > 1200.1) {
			// Function to process custom attributes
			function revealWithAttributes(selector, baseConfig) {
				document.querySelectorAll(selector).forEach((element) => {
					// Read custom attributes
					const delay = element.getAttribute("data-delay") || baseConfig.delay;
					const duration = element.getAttribute("data-duration") || baseConfig.duration;
					const distance = element.getAttribute("data-distance") || baseConfig.distance;

					// Create a new configuration based on custom attributes
					const config = {
						...baseConfig,
						delay: parseInt(delay, 10),
						duration: parseInt(duration, 10),
						distance: distance,
					};

					// Apply ScrollReveal
					ScrollReveal().reveal(element, { mobile: false, once: true, ...config, easing: "cubic-bezier(0.5, 0, 0, 1)" });

					// Trigger animation for elements already in viewport
					const rect = element.getBoundingClientRect();
					if (rect.top < window.innerHeight && rect.bottom >= 0) {
						ScrollReveal().reveal(element, config);
					}
				});
			}

			// Base configurations
			let fadeDown = { origin: "top", duration: 1000, delay: 200, distance: "20px", interval: 50, reset: false };
			let fadeUp = { origin: "bottom", duration: 1000, delay: 200, distance: "20px", interval: 50, reset: false };
			let fadeLeft = { origin: "left", duration: 1000, delay: 200, distance: "25%", interval: 150, reset: false };
			let fadeRight = { origin: "right", duration: 1000, delay: 200, distance: "25%", interval: 150, reset: false };
			let fadeIn = { origin: "top", duration: 1100, delay: 220, distance: 0, interval: 150, reset: false };

			// Call the function for each selector
			revealWithAttributes(".fd-down", fadeDown);
			revealWithAttributes(".fd-up", fadeUp);
			revealWithAttributes(".fd-left", fadeLeft);
			revealWithAttributes(".fd-right", fadeRight);
			revealWithAttributes(".fd-in", fadeIn);
		}

	},
	a11yUser: () => {
		const wrapForms = document.querySelectorAll(".wrap-form");
		wrapForms.forEach(function (form) {
			const submitInput = form.querySelector("input[type='submit']");
			const labelFor = submitInput.getAttribute("name");
			const labelSubmit = form.querySelector(".frm-btnwrap .label");
			if (labelFor !== null) {
				if (labelSubmit !== null) {
					labelSubmit.textContent = "Submit Button";
					labelSubmit.setAttribute("for", labelFor);
				}
			}
		});
	},
	hideElement: () => {
		if ($(window).width() < 1200.1) {
			[".searchbox", ".nav-primary-menu"]
				.map((selector) => document.querySelector(selector))
				.forEach((el) => (el.style.display = "flex"));
		}
	},
	init: () => {
		generalFunction.scrollReveal();
		generalFunction.hideElement();
	},
};




function mappingFunc() {



}
